import { useQuery } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';

import SidebarLayout from 'layouts/SidebarLayout';

import Button from 'components/Button';
import DetailsPanel from 'components/DetailsPanel';
import ErrorMessage from 'components/ErrorMessage';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';

import { logout } from 'utils/auth';

const SETTINGS_QUERY = gql(`
  query UserSettings {
    dashboard {
      id
      user {
        id
        fullName
        email
        phoneNumber
      }
    }
  }
`);

const SettingsPage: FC = () => {
  const { loading, error, data, refetch } = useQuery(SETTINGS_QUERY);

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

    const user = data.dashboard.user;

    if (!user) return null;

    return (
      <>
        <DetailsPanel
          title="User Details"
          data={[
            { label: 'Name', value: user.fullName },
            { label: 'Phone Number', value: user.phoneNumber },
            { label: 'Email', value: user.email },
          ]}
        />
        <Button onClick={logout}>Logout</Button>
      </>
    );
  };

  return (
    <SidebarLayout>
      <Navbar
        title="Settings"
        subTitle="Manage your account, security and notification preferences"
      />
      {renderContent()}
    </SidebarLayout>
  );
};

export default SettingsPage;
